<template>
  <div>
    <v-card tile>
      <v-card-title>取引データ</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="6">
            <text-field-like
                v-model="message.id"
                label="取引データID"
                hide-details>
            </text-field-like>
          </v-col>
          <v-col cols="6">
            <text-field-like
                :value="tradeContract.name || ''"
                label="取引契約名"
                readonly
                hide-details>
            </text-field-like>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <text-field-like
                :value="dataComponentModel.name"
                :value-hds-id="dataComponentModel.id"
                label="データ名称"
                hide-details>
            </text-field-like>
          </v-col>

          <v-col cols="6">
            <text-field-like
                :value="dataComponentModel.description || ''"
                label="説明"
                placeholder="未設定"
                multi-line
                hide-details>
            </text-field-like>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <text-field-like
                :value="senderOwner.name || ''"
                :placeholder="'\u2E3B'"
                label="提供者"
                hide-details>
              <template #default="{value}">
                {{ value }}
                <icon-btn
                    type="view"
                    tooltip="事業者詳細"
                    tooltip-placement="right"
                    @click="senderOwnerDialog = senderOwner.id"
                    style="margin-top: -3px;"
                    class="ml-2"
                    x-small>
                </icon-btn>
              </template>
            </text-field-like>
          </v-col>

          <v-col cols="6">
            <text-field-like
                :value="receiverOwner.name || ''"
                :placeholder="'\u2E3B'"
                label="利用者"
                hide-details>
              <template #default="{value}">
                {{ value }}
                <icon-btn
                    type="view"
                    tooltip="事業者詳細"
                    tooltip-placement="right"
                    @click="receiverOwnerDialog = receiverOwner.id"
                    style="margin-top: -3px;"
                    class="ml-2"
                    x-small>
                </icon-btn>
              </template>
            </text-field-like>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <owner-info-dialog
        v-model="receiverOwnerDialog">
    </owner-info-dialog>

    <owner-info-dialog
        v-model="senderOwnerDialog">
    </owner-info-dialog>
  </div>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import OwnerInfoDialog from "@/components/organisms/OwnerInfoDialog.vue";
import IconBtn from "@/components/molecules/IconBtn.vue";

export default {
  name: 'MessageInfo',
  components: {IconBtn, OwnerInfoDialog, TextFieldLike},
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      receiverOwnerDialog: false,
      senderOwnerDialog: false,
    };
  },
  computed: {
    dataComponentModel() {
      return this.message.dataComponentModel || {};
    },
    receiverOwner() {
      return this.message.receiverOwner || {};
    },
    senderOwner() {
      return this.message.senderOwner || {};
    },
    tradeContract() {
      return this.message.tradeContract || {};
    }
  }
}
</script>
